import * as React from "react";

function SvgClockIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={25}
      height={25}
      {...props}
    >
      <defs>
        <path
          d="M16.25 17.42l-5.5-3.87V5.9h2.5v6.35l4.44 3.13-1.44 2.04z"
          id="clock-icon_svg__a"
        />
        <path
          d="M12.5 1.88C6.64 1.88 1.87 6.64 1.87 12.5c0 5.86 4.77 10.63 10.63 10.63 5.86 0 10.62-4.77 10.62-10.63 0-5.86-4.76-10.62-10.62-10.62m0 23.12C5.61 25 0 19.39 0 12.5S5.61 0 12.5 0 25 5.61 25 12.5 19.39 25 12.5 25"
          id="clock-icon_svg__b"
        />
      </defs>
      <use xlinkHref="#clock-icon_svg__a" fill="#797a7c" />
      <use
        xlinkHref="#clock-icon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <g>
        <use xlinkHref="#clock-icon_svg__b" fill="#797a7c" />
        <use
          xlinkHref="#clock-icon_svg__b"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
    </svg>
  );
}

export default SvgClockIcon;
